import type { FaireProductEntity } from "../../entity_types/product";

export const p_gcexqdu57f: FaireProductEntity = {
  token: "p_gcexqdu57f",
  type: "product",
  name: "The Original Wine Bottle Glass",
  brandToken: "b_6qajwqdzz3",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f3f0429d0ed4152420575f50b92fba2d7034d4300821916476c665f23e533c28.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fbfa936cb4f453184c56154e8b77d1c8360e54a6d16605b44c28fbd7226da7d1.jpeg",
    "https://cdn.faire.com/fastly/129c32980285be18bd0ff82abae150194fb1a7b7fe3ea74746c5184d188271a3.jpeg",
  ],
  priceDollars: 13.85,
  description:
    "Finally, a wine glass that fits your needs! \nOur Wine Bottle Glass is PERFECT for the wine snob in your life (even if it’s yourself). It holds an entire 750mL bottle of wine—or just one serving *wink wink*. Choose from a variety of hilarious phrases, letting everyone know that a run-of-the-mill glass just won’t cut it. A viral sensation, the patented Wine Bottle Glass has been featured on the Today Show, BuzzFeed, The Tonight Show, and more.\n\n * holds an entire 750mL bottle of delicious wine \n * a hilarious gift for wine lovers & holidays \n * made of real glass \n * patented design! US D719,409 S",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:42.130Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
